import React, { useState } from "react";
import { Button } from "../Button/index"
import { Input } from "../Input/index"
import Android from "../../assets/android.svg"
import Apple from "../../assets/apple.svg"
import rightArrow from "../../assets/right2.svg"
import Frame1 from "../../assets/frame1.svg"
import Frame2 from "../../assets/frame2.svg"
import menuBar from "../../assets/menu.svg"
import "./index.css"
export const HeroSection = ({ joinWaitlist, load,setEmail }) => {
    const [isOpen, setIsOpen] = useState(false);
    const active = window.location.pathname.replace('/', '')
    const toggle = () => setIsOpen(!isOpen);
    return (
        <div className="">
            <div className="show-mobile-int container-art">
                <div className="hero-tap-bar">Skiled hands, just a tap away <img className="pl-2" src={rightArrow} /></div>
            </div>
            <div className="hero-sec ">

                <div className="row">
                    <div className="col-md-6 col-12 hero-main-sec animate__animated animate__backInLeft">
                        <div className="show-web-int mb-3">
                            <div className="hero-tap-bar">Skiled hands, just a tap away <img className="pl-2" src={rightArrow} /></div>
                        </div>
                        <div className="hero-head">Find Skilled Artisans <span className="primary"> Near You</span></div>
                        <div className="hero-sub pt-3">Connect with skilled professionals for repairs, home improvement,and everyday services.
                        Hire confidently, anytime, anywhere.

                        </div>
                        <br />
                        <div className="flex-sys show-web-int pt-3">
                            <Input className="input-className " onChange={(e) => setEmail(e?.target?.value)} style={{ width: '410px' }} placeholder='Email Address' />
                            <Button className="primary-button w-25 ml-3" text="Join Waitlist" onClick={joinWaitlist} loading={load} />
                        </div>
                        <div className="flex-sys show-mobile-int pt-3">
                            <Input className="input-className" onChange={(e) => setEmail(e?.target?.value)}  style={{ width: '100%' }} placeholder='Email Address' />
                            <Button className="secondary-button w-25 mt-3 w-100" text="Join Waitlist" onClick={joinWaitlist} loading={load} />
                        </div>
                        <br />
                        <div className="show-web-int d-flex justify-content align-items-center">
                            <img src={Apple} className="mr-3" />
                            <img src={Android} />
                        </div>
                        <div className="show-mobile-int">
                            <div className="d-flex container align-items-center">
                                <img src={Apple} className="mr-2" width={"50%"} />
                                <img src={Android} width={"50%"} />
                            </div>
                        </div>

                    </div>
                    <div className="col-md-6 col-12 mt-4 w-100 show-mobile-int">
                        <div className="d-flex flex-wrap gap-5 gap-md-1">
                            <div className="image-box">
                                <img src={Frame1} className="image-fit" alt="Frame 1" />
                            </div>
                            <div className="image-box">
                                <img src={Frame2} className="image-fit" alt="Frame 2" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>

    );
};

